import { makeAutoObservable, runInAction } from 'mobx';
import { Match } from 'navigo';
import { NotificationSettingsInput } from 'dtos/users/NotificationSettingsInput';
import { AuthStore } from 'stores/users/AuthStore';
import { createForm } from 'forms/notificationSettingsForm';
import { LoadStatus } from 'utils/types';
import { serverUri } from 'utils/config';
import { emailNotificationsOptions } from 'utils/options';

export class NotificationSettingsStore {
  form = createForm();
  status: LoadStatus = 'none';
  message?: string;

  constructor(private readonly authStore: AuthStore) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  activate(match: Match) {
    this.status = 'none';
    this.message = undefined;

    const { emailNotifications } = this.authStore.currentUser || {};

    this.form.set('default', {
      emailNotifications: emailNotifications ? emailNotifications : emailNotificationsOptions.daily,
    });
    this.form.reset();
  }

  async changeNotificationSettings() {
    this.status = 'loading';
    this.message = undefined;
    const { isValid } = await this.form.validate({ showErrors: true });
    if (!isValid) {
      return;
    }
    const { emailNotifications } = this.form.values();
    const dto: NotificationSettingsInput = {
      emailNotifications: emailNotifications || emailNotificationsOptions.daily,
    };
    try {
      const response = await this.authStore.fetchWithAuth(`${serverUri}/user/notifications`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dto),
      });
      if (!response.ok) throw new Error('Error changing notification settings.');
      runInAction(() => {
        this.status = 'success';
        this.message = 'Your notification settings were changed.';
      });
    } catch (err) {
      runInAction(() => {
        this.status = 'error';
        this.message = 'Unable to change notification settings. Please try again.';
      });
    }
  }
}
